import { common } from './common';
import { crypto } from './crypto';
export function publicKeyToScriptHash(publicKey) {
    return common.uInt160ToString(crypto.publicKeyToScriptHash(common.stringToECPoint(publicKey)));
}
export function publicKeyToAddress(publicKey) {
    return crypto.scriptHashToAddress({
        addressVersion: common.NEO_ADDRESS_VERSION,
        scriptHash: crypto.publicKeyToScriptHash(common.stringToECPoint(publicKey)),
    });
}
export function scriptHashToAddress(scriptHash) {
    return crypto.scriptHashToAddress({
        addressVersion: common.NEO_ADDRESS_VERSION,
        scriptHash: common.stringToUInt160(scriptHash),
    });
}
export function addressToScriptHash(address) {
    return common.uInt160ToString(crypto.addressToScriptHash({
        addressVersion: common.NEO_ADDRESS_VERSION,
        address,
    }));
}
export function wifToPrivateKey(wif) {
    return common.privateKeyToString(crypto.wifToPrivateKey(wif, common.NEO_PRIVATE_KEY_VERSION));
}
export function privateKeyToWIF(privateKey) {
    return crypto.privateKeyToWIF(common.stringToPrivateKey(privateKey), common.NEO_PRIVATE_KEY_VERSION);
}
export function privateKeyToScriptHash(privateKey) {
    return common.uInt160ToString(crypto.privateKeyToScriptHash(common.stringToPrivateKey(privateKey)));
}
export function privateKeyToAddress(privateKey) {
    return crypto.privateKeyToAddress({
        addressVersion: common.NEO_ADDRESS_VERSION,
        privateKey: common.stringToPrivateKey(privateKey),
    });
}
export function privateKeyToPublicKey(privateKey) {
    return common.ecPointToString(crypto.privateKeyToPublicKey(common.stringToPrivateKey(privateKey)));
}
export function isNEP2(encryptedKey) {
    return crypto.isNEP2(encryptedKey);
}
export async function encryptNEP2(options) {
    const { password, privateKey } = options;
    return crypto.encryptNEP2({
        addressVersion: common.NEO_ADDRESS_VERSION,
        privateKey: common.stringToPrivateKey(privateKey),
        password,
    });
}
export async function decryptNEP2(options) {
    const { password, encryptedKey } = options;
    const privateKey = await crypto.decryptNEP2({
        addressVersion: common.NEO_ADDRESS_VERSION,
        encryptedKey,
        password,
    });
    return common.privateKeyToString(privateKey);
}
export function createPrivateKey() {
    return common.privateKeyToString(crypto.createPrivateKey());
}

//# sourceMappingURL=helpers.js.map
